type FeatureFlag = {
  featureName: FeatureFlagName;
  customerId: string;
  isEnabled: boolean;
  expiration?: number | null;
};

export enum FeatureFlagName {
  Transcription = "Transcription",
  BulkExport = "BulkExport",
  Views = "Views",
  Archie = "Archie",
  EditableDashboards = "EditableDashboards",
}

export const FEATURE_FLAG_LABELS: Record<FeatureFlagName, string> = {
  [FeatureFlagName.Transcription]: "Transcription",
  [FeatureFlagName.BulkExport]: "Bulk Export",
  [FeatureFlagName.Views]: "Views",
  [FeatureFlagName.Archie]: "Archie AI Assistant",
  [FeatureFlagName.EditableDashboards]: "Editable Dashboards",
};

export default FeatureFlag;
